import { tableSortFilter } from '@/utils/arrayProcessing';
import { InvoiceDryRunStatus, InvoiceRun, ProviderInvoice } from '../types';

export const INVOICE_RUNS_TABLE_HEAD = [
  { id: 'emptyCell' },
  { id: 'id', label: 'ID', align: 'left', width: '20px' },
  { id: 'start_date', label: 'Start Date', align: 'left' },
  { id: 'end_date', label: 'End Date', align: 'left' },
  { id: 'running', label: 'Status', align: 'left' },
  { id: 'processed_jobs', label: 'Job Processed', align: 'left' },
  { id: 'created_at', label: 'Created at', align: 'left' },
];

export const PROVIDER_INVOICES_TABLE_HEAD = [
  { id: 'emptyCell' },
  { id: 'id', label: 'ID', align: 'left' },
  { id: 'users.first_name', label: 'Provider', align: 'left' },
  { id: 'seen', label: 'Seen', align: 'left' },
  { id: 'accepted', label: 'Accepted', align: 'left' },
  { id: 'invoice_status.display', label: 'Status', align: 'left' },
  { id: 'date_from', label: 'Date From', align: 'left' },
  { id: 'date_to', label: 'Date To', align: 'left' },
  { id: 'due_date', label: 'Due Date', align: 'left' },
  { id: 'total', label: 'Total', align: 'left' },
  { id: '_count.provider_invoice_items', label: 'Jobs', align: 'left' },
  { id: 'cleaner_notes', label: 'Provider Notes', align: 'left' },
  { id: 'admin_notes', label: 'Admin notes', align: 'left' },
  { id: 'created_at', label: 'Created at', align: 'left' },
];

export const INVOICE_DRY_RUN_STATUSES: InvoiceDryRunStatus[] = [
  'QUEUED',
  'RUNNING',
  'COMPLETED',
  'FAILED',
];

export const INVOICE_DRY_RUNS_TABLE_HEAD = [
  { id: 'id', label: 'ID', align: 'left', width: 80 },
  { id: 'date_range', label: 'Date range', align: 'left' },
  { id: 'requested_by', label: 'Requested by', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'total_jobs', label: 'Total jobs', align: 'right' },
  { id: 'processed_jobs', label: 'Processed jobs', align: 'right' },
  { id: 'issue_count', label: 'Issues', align: 'right' },
  {
    id: 'provider_invoice_count',
    label: 'Provider invoices',
    align: 'right',
  },
  { id: 'created_at', label: 'Created at', align: 'left' },
];

export const INVOICE_DRY_RUN_ISSUES_TABLE_HEAD = [
  { id: 'type', label: 'Type', align: 'left' },
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'details', label: 'Details', align: 'left' },
  { id: 'provider_id', label: 'Provider ID', align: 'left' },
  { id: 'booking_id', label: 'Booking ID', align: 'left' },
  { id: 'session_id', label: 'Session ID', align: 'left' },
  { id: 'link', label: 'Link', align: 'left' },
];

export const INVOICE_DRY_RUN_PROVIDER_PREVIEWS_TABLE_HEAD = [
  { id: 'provider', label: 'Provider', align: 'left' },
  { id: 'date_range', label: 'Date range', align: 'left' },
  { id: 'total', label: 'Total', align: 'right' },
  { id: 'base_total', label: 'Base total', align: 'right' },
  { id: 'adjustments_total', label: 'Adjustments', align: 'right' },
  { id: 'adjusted_total', label: 'Adjusted total', align: 'right' },
  { id: 'item_count', label: 'Items', align: 'right' },
];

export const INVOICE_DRY_RUN_LINE_ITEMS_TABLE_HEAD = [
  { id: 'job_id', label: 'Job ID', align: 'left' },
  { id: 'client', label: 'Client', align: 'left' },
  { id: 'description', label: 'Description', align: 'left' },
  { id: 'job_timestamp', label: 'Job timestamp', align: 'left' },
  { id: 'hours', label: 'Hours', align: 'right' },
  { id: 'price_per_hour', label: 'Price/h', align: 'right' },
  { id: 'subtotal', label: 'Subtotal', align: 'right' },
  { id: 'cleaning_products', label: 'Cleaning products', align: 'right' },
  { id: 'total', label: 'Total', align: 'right' },
];

export function applySortFilterInvoices({
  tableData,
  comparator,
  filterStartDate,
  filterEndDate,
}: {
  tableData: InvoiceRun[];
  comparator: (a: any, b: any) => number;
  filterStartDate: string | null;
  filterEndDate: string | null;
}) {
  tableData = tableSortFilter(tableData, comparator);
  // console.log(filterEndDate, filterStartDate);

  if (filterStartDate && filterEndDate) {
    tableData = tableData.filter(
      (invoice) =>
        new Date(invoice.start_date) >= new Date(filterStartDate) &&
        new Date(invoice.start_date) <= new Date(filterEndDate)
    );
  }

  if (filterStartDate && !filterEndDate) {
    tableData = tableData.filter(
      (invoice) => new Date(invoice.start_date) >= new Date(filterStartDate)
    );
  }
  if (!filterStartDate && filterEndDate) {
    tableData = tableData.filter(
      (invoice) => new Date(invoice.start_date) <= new Date(filterEndDate)
    );
  }

  return tableData;
}

export function applySortFilterInvoicesList({
  tableData,
  comparator,
}: {
  tableData: ProviderInvoice[];
  comparator: (a: any, b: any) => number;
}) {
  tableData = tableSortFilter(tableData, comparator);

  return tableData;
}
